var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 191,
    height: 184.5,
    viewBox: "0 0 191 184.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "undraw_Post_online_re_1b82",
    transform: "translate(0.5 -221.282)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2110",
    "data-name": "Path 2110",
    d: "M561.675,356.2H390.027a9.193,9.193,0,0,1-9.176-9.19V291.871a9.193,9.193,0,0,1,9.176-9.19H561.675a9.193,9.193,0,0,1,9.176,9.19v55.139A9.193,9.193,0,0,1,561.675,356.2Z",
    transform: "translate(-380.851 -60.899)",
    fill: "#707070",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2112",
    "data-name": "Path 2112",
    d: "M567.818,349.108h-60a4.325,4.325,0,1,1,0-8.649h60a4.325,4.325,0,1,1,0,8.649Z",
    transform: "translate(-450.258 -93.539)",
    fill: "#fe6502"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2113",
    "data-name": "Path 2113",
    d: "M623.5,382.656H507.814a4.325,4.325,0,1,1,0-8.649H623.5a4.325,4.325,0,0,1,0,8.649Z",
    transform: "translate(-450.417 -112.647)",
    fill: "#b2b2b2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_200",
    "data-name": "Ellipse 200",
    cx: 16.217,
    cy: 16.217,
    r: 16.217,
    transform: "translate(12.595 242.324)",
    fill: "#fe6502",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2121",
    "data-name": "Path 2121",
    d: "M588.618,523.067H492.965a5.119,5.119,0,0,1-5.114-5.114V487.272a5.119,5.119,0,0,1,5.114-5.114h95.653a5.119,5.119,0,0,1,5.114,5.114v30.681A5.119,5.119,0,0,1,588.618,523.067ZM492.965,482.76a4.517,4.517,0,0,0-4.512,4.512v30.681a4.517,4.517,0,0,0,4.512,4.512h95.653a4.517,4.517,0,0,0,4.512-4.512V487.272a4.517,4.517,0,0,0-4.512-4.512Z",
    transform: "translate(-441.455 -174.005)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2122",
    "data-name": "Path 2122",
    d: "M591.887,519.121H558.5a2.406,2.406,0,1,1,0-4.813h33.388a2.406,2.406,0,0,1,0,4.813Z",
    transform: "translate(-479.993 -192.138)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2123",
    "data-name": "Path 2123",
    d: "M622.869,537.788H558.5a2.406,2.406,0,1,1,0-4.813h64.37a2.406,2.406,0,0,1,0,4.813Z",
    transform: "translate(-480.029 -202.715)",
    fill: "#383838"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2126",
    "data-name": "Path 2126",
    d: "M588.618,654.067H492.965a5.119,5.119,0,0,1-5.114-5.114V618.272a5.119,5.119,0,0,1,5.114-5.114h95.653a5.119,5.119,0,0,1,5.114,5.114v30.681A5.119,5.119,0,0,1,588.618,654.067ZM492.965,613.76a4.517,4.517,0,0,0-4.512,4.512v30.681a4.517,4.517,0,0,0,4.512,4.512h95.653a4.517,4.517,0,0,0,4.512-4.512V618.272a4.517,4.517,0,0,0-4.512-4.512Z",
    transform: "translate(-441.455 -248.284)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2127",
    "data-name": "Path 2127",
    d: "M591.887,650.121H558.5a2.406,2.406,0,1,1,0-4.813h33.388a2.406,2.406,0,0,1,0,4.813Z",
    transform: "translate(-479.993 -266.447)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2128",
    "data-name": "Path 2128",
    d: "M622.869,668.788H558.5a2.406,2.406,0,1,1,0-4.813h64.37a2.406,2.406,0,0,1,0,4.813Z",
    transform: "translate(-480.029 -276.993)",
    fill: "#383838"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4066",
    "data-name": "Group 4066",
    transform: "translate(9.982 242.493)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "notifications-24px",
    d: "M14.164,27.274A2.548,2.548,0,0,0,16.7,24.733H11.623A2.54,2.54,0,0,0,14.164,27.274Zm7.623-7.623V13.3c0-3.9-2.084-7.165-5.717-8.029V4.406a1.906,1.906,0,0,0-3.811,0V5.27C8.612,6.133,6.541,9.386,6.541,13.3v6.352L4,22.192v1.27H24.327v-1.27Z",
    transform: "translate(1.524 0.057)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2440",
    "data-name": "Rectangle 2440",
    width: 31,
    height: 30,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_45",
    "data-name": "Ellipse 45",
    transform: "translate(18 3)",
    fill: "#fe6502",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 4.5,
    r: 4,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4067",
    "data-name": "Group 4067",
    transform: "translate(52.981 320.493)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "notifications-24px-2",
    "data-name": "notifications-24px",
    d: "M9.818,16.682a1.459,1.459,0,0,0,1.455-1.455H8.364A1.454,1.454,0,0,0,9.818,16.682Zm4.364-4.364V8.682a4.431,4.431,0,0,0-3.273-4.6V3.591a1.091,1.091,0,0,0-2.182,0v.495a4.418,4.418,0,0,0-3.273,4.6v3.636L4,13.773V14.5H15.636v-.727Z",
    transform: "translate(-0.838 -1.036)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2440-2",
    "data-name": "Rectangle 2440",
    width: 17.746,
    height: 17.173,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_45-2",
    "data-name": "Ellipse 45",
    transform: "translate(10.304 1.717)",
    fill: "#a04306",
    stroke: "#23232b",
    strokeWidth: 0.7
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.576,
    cy: 2.576,
    r: 2.576,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.576,
    cy: 2.576,
    r: 2.226,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4068",
    "data-name": "Group 4068",
    transform: "translate(52.981 376.493)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "notifications-24px-3",
    "data-name": "notifications-24px",
    d: "M9.818,16.682a1.459,1.459,0,0,0,1.455-1.455H8.364A1.454,1.454,0,0,0,9.818,16.682Zm4.364-4.364V8.682a4.431,4.431,0,0,0-3.273-4.6V3.591a1.091,1.091,0,0,0-2.182,0v.495a4.418,4.418,0,0,0-3.273,4.6v3.636L4,13.773V14.5H15.636v-.727Z",
    transform: "translate(-0.838 -1.036)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2440-3",
    "data-name": "Rectangle 2440",
    width: 17.746,
    height: 17.173,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_45-3",
    "data-name": "Ellipse 45",
    transform: "translate(10.304 1.717)",
    fill: "#a04306",
    stroke: "#23232b",
    strokeWidth: 0.7
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.576,
    cy: 2.576,
    r: 2.576,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.576,
    cy: 2.576,
    r: 2.226,
    fill: "none"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyNotifications);
export default __webpack_public_path__ + "static/media/empty-notifications.d658b4f818f801f046304c66d142a4cf.svg";
export { ForwardRef as ReactComponent };